module.exports = __webpack_public_path__ + "zambia.svg?37586be9b9f6c737dbf1f400e51d1739";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/zambia.svg
// module id = 343
// module chunks = 10